import { getDefaultClipboardItem } from '@root/resources/file/file.helpers';

const getClipboardItem = (doc) => getDefaultClipboardItem(doc.content);

export default getClipboardItem;
